import { render } from "./wizard.vue?vue&type=template&id=7fb27126&scoped=true"
import script from "./wizard.vue?vue&type=script&lang=js"
export * from "./wizard.vue?vue&type=script&lang=js"

import "./wizard.vue?vue&type=style&index=0&id=7fb27126&lang=scss"
import "./wizard.vue?vue&type=style&index=1&id=7fb27126&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb27126"]])

export default __exports__